export const TYPES_PRESTATION = [
  { value: 'consulting', label: 'Consulting', cls: 'bg-teal-100 text-teal-700' },
  { value: 'gestion', label: 'Gestion', cls: 'bg-sky-100 text-sky-700' },
  { value: 'autre', label: 'Autre', cls: 'bg-slate-100 text-slate-700' },
];
export const TYPE_PRESTATION = Object.fromEntries(TYPES_PRESTATION.map(t => [t.value, t]));

export const STATUTS_PRESTATION = [
  { value: 'brouillon', label: 'Brouillon', cls: 'bg-slate-100 text-slate-700' },
  { value: 'en_cours', label: 'En cours', cls: 'bg-emerald-100 text-emerald-700' },
  { value: 'termine', label: 'Terminée', cls: 'bg-indigo-100 text-indigo-700' },
  { value: 'annule', label: 'Annulée', cls: 'bg-red-100 text-red-700' },
];
export const STATUT_PRESTATION = Object.fromEntries(STATUTS_PRESTATION.map(s => [s.value, s]));

export const CRENEAUX = [
  { value: 'journee', label: 'Journée' },
  { value: 'matin', label: 'Matin' },
  { value: 'apres_midi', label: 'Après-midi' },
];

export const emptyPrestation = (extra = {}) => ({
  type_prestation: 'consulting', intitule: '', client_id: null, client: '', contact: '', lieu: '', description: '', code_action_client: '',
  statut: 'brouillon', mode_interventions: 'journees', interventions: [], periodes: [], projet_commercial_id: null, ...extra,
});

export const fmtDate = (d) => (d ? d.split('-').reverse().join('/') : '—');
